import React, { Component } from 'react';

// Components and Others
import PropTypes from 'prop-types';
import ModalUtils from 'utils/ModalUtils';
import PortfolioService from 'services/modules/PortfolioService';

import PortfolioTabs from 'utils/enum/PortfolioEnum';

const PortfolioSettingsDialogContainer = (WrappedComponent) => class extends Component {
  static propTypes = {
      isEditing: PropTypes.bool,
      onClose: PropTypes.func.isRequired,
      open: PropTypes.bool.isRequired,
      onSave: PropTypes.func.isRequired,
      productId: PropTypes.number,
      portfolioId: PropTypes.number,
  };

  static defaultProps = {
      isEditing: false,
      productId: null,
      portfolioId: null,
  }

  constructor(props) {
      super(props);
      this.portfolioService = new PortfolioService();

      this.initBind();
  }

  /* eslint-disable react/state-in-constructor */
  state = {
      record: {
          creditReportingCompanyId: null,
          name: '',
          lotId: null,
          convenienceFee: 0,
          achConvenienceFee: 0,
      },
      isLoading: false,
      selectedTab: PortfolioTabs.DETAIL,
      listCreditCompany: [],
  };

  componentDidMount() {
      const { props: { isEditing } } = this;
      if (isEditing) {
          this.getPortfolioDetail();
      }
      this.getPortfolioCreditCompany();
  }

  onTabChange(_, value) {
      if (value === PortfolioTabs.DETAIL) {
          this.setState({ selectedTab: PortfolioTabs.DETAIL });
      } else if (value === PortfolioTabs.NOTES) {
          this.setState({ selectedTab: PortfolioTabs.NOTES });
      }
  }

  onChangeValue(field, value) {
      this.setState(({ record }) => {
          const newRecord = { ...record };
          newRecord[field] = value;
          return { record: newRecord };
      });
  }

  getPortfolioDetail() {
      const { props: { portfolioId } } = this;

      this.setState({ isLoading: true });
      this.portfolioService.getPortfolioDetail({ id: portfolioId })
          .then((response) => {
              const { data, graphQLErrors } = response;

              if (graphQLErrors) {
                  ModalUtils.errorMessage(graphQLErrors);
                  return;
              }

              if (data && data.portfolio) {
                  const { portfolio } = data;
                  this.setState({ record: portfolio, isLoading: false });
              }
          });
  }

  getPortfolioCreditCompany() {
      this.portfolioService.getPortfolioCreditCompanies()
          .then((response) => {
              const { data, graphQLErrors } = response;

              if (graphQLErrors) {
                  ModalUtils.errorMessage(graphQLErrors);
                  return;
              }
              if (data && data.portfolioCreditCompanies) {
                  const { portfolioCreditCompanies } = data;
                  this.setState({ listCreditCompany: portfolioCreditCompanies });
              }
          });
  }

  initBind() {
      this.onChangeValue = this.onChangeValue.bind(this);
      this.getPortfolioDetail = this.getPortfolioDetail.bind(this);
      this.onTabChange = this.onTabChange.bind(this);
  }

  render() {
      const { props, state } = this;

      return (
          <WrappedComponent
              {...props}
              {...state}
              onSave={props.onSave}
              onClose={props.onClose}
              onChangeValue={this.onChangeValue}
              onTabChange={this.onTabChange}
          />
      );
  }
};

export default PortfolioSettingsDialogContainer;
